export const GoogleMapApiConfig = 'AIzaSyAfjpdXoAFBFMNpuHt55DModDiKpUrzKbI';